import dateTimeHelper from './datetimeHelper';

class serviceHelper {
  static ConvertAllPropertyToString(item) {
    for (const key in item) {
      if (Object.hasOwnProperty.call(item, key)) {
        if (typeof item[key] === 'boolean' && item[key] === false) {
          item[key] = 'false';
        }
        if (!item[key]) {
          item[key] = '';
        } else if (dateTimeHelper.isItAValidTime(item[key])) {
          item[key] = new Date(item[key]);
        } else {
          item[key] = item[key].toString();
        }
      }
    }
    return item;
  }

  static ConvertAllPropertyToStringForReport(item) {
    const newItem = { ...item };
    for (const key in newItem) {
      if (Object.hasOwnProperty.call(newItem, key)) {
        if (typeof newItem[key] === 'boolean' && newItem[key] === false) {
          newItem[key] = 'false';
        }
        if (!newItem[key]) {
          newItem[key] = '';
        } else if (dateTimeHelper.isItAValidTime(newItem[key])) {
          newItem[key] = dateTimeHelper.toYYYYsMMsDDsHHsMM(newItem[key]);
        } else {
          if (Array.isArray(newItem[key]) && newItem[key].length !== 0 && typeof newItem[key][0] === 'object') {
            newItem[key] = newItem[key].map((i) => i.value).toString();
          }
          newItem[key] = newItem[key].toString();
        }
      }
    }
    return newItem;
  }

  static ConvertToFormData(item) {
    const data = new FormData();

    for (const key in item) {
      data.append(key, item[key]);
    }

    return data;
  }
}

export default serviceHelper;
